import ButtonCloseMenu from 'components/button-close'
import { useSession } from 'contexts/session-context'
import { useContext, useEffect, useState } from 'react'
import { LoaderContext } from 'contexts/loader-context'
import useMainClass from 'hooks/use-main-cass'
import Button from 'components/button'
import textServices from 'services/text-services'
import { Link } from 'react-router-dom'
import useRouter from 'hooks/use-router'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { formatDate } from '../utils/formatDate'
import { fetchHistoryId, timeResult } from '../utils/functions'
import Steps from './Steps'
import NumberOrder from './NumberOrder'

interface IDetails {
  setShowDetails: (arg0: any) => void
  setShowOrderNumber: (value: boolean) => void
  showDetails: any
  productExchangeCoupon: any
  showOrderNumber: boolean
}

const Details = ({
  setShowDetails,
  showDetails,
  productExchangeCoupon,
  setShowOrderNumber,
  showOrderNumber
}: IDetails) => {
  const [history, setHistory] = useState<null | any>(null)
  const [{ data: session }] = useSession()
  const { setFooter } = useContext(LoaderContext)
  const { push } = useRouter()
  useMainClass('profile__history__id')

  console.log(showDetails)

  const [buttonConfig, setButtonConfig] = useState<{ text: string; action: () => void; disabled: boolean }>({
    text: 'MOSTRAR NÚMERO DE ORDEN',
    action: () => setShowOrderNumber(showDetails),
    disabled: false
  })

  const goBack = () => {
    setShowDetails(null)
  }

  useEffect(() => {
    const getHistory = async () => {
      const data = await fetchHistoryId(showDetails?.id, `${((session as any)?._tokenResponse as any)?.idToken}`)
      if (data) setHistory(data)
    }

    getHistory()

    const div = document.querySelector('.profile__title-container') as HTMLElement | null
    setFooter(false)
    if (div) div.style.display = 'none'

    return () => {
      if (div) div.style.display = 'flex'
      setFooter(true)
    }
  }, [])

  const courierExists = () => {
    const url = history?.currier?.url?.replace('{trackingNumber}', history?.currier?.trakingNumber)

    if (url) {
      dlTrackEvent('user_interaction', {
        action: 'click',
        element: 'ver courier',
        section: 'tracking :: prize'
      })
      window.open(url, '_blank')
    }
  }

  const getCouponText = (details) => {
    if (details?.orderStatus === 6) {
      return textServices.findByText('profile/coupon/activate', { es: 'ACTIVAR', en: 'ACTIVATE' })
    }
    if (timeResult(details?.temporalCouponExpiresAt)) {
      return textServices.findByText('profile/coupon/active', { es: 'Ver cupón activo', en: 'View coupon active' })
    }
    if (details?.orderStatus === 7 && !timeResult(details?.temporalCouponExpiresAt)) {
      return textServices.findByText('profile/coupon/used', { es: 'cupón usado', en: 'coupon used' })
    }
    return 'ACTIVAR CUPÓN'
  }

  const canExchangeCoupon = (details) => {
    return details?.orderStatus === 6 || timeResult(details?.temporalCouponExpiresAt)
  }

  useEffect(() => {
    if (!history) return

    const buttonConfigs = {
      currier: {
        text: 'VER COURRIER',
        action: () => courierExists(),
        disabled: false
      },
      temporalCouponCode: {
        text: getCouponText(showDetails),
        action: () => {
          if (canExchangeCoupon(showDetails)) {
            productExchangeCoupon(showDetails)
          }
        },
        disabled: !canExchangeCoupon(showDetails)
      },
      default: {
        text: textServices.findByText('profile/prize/detail/buttonDefault', {
          es: 'MOSTRAR ID',
          en: 'SHOW ID'
        }),
        action: () => push('/profile/identificacion'),
        disabled: false
      }
    }

    const configKey = history.currier ? 'currier' : showDetails.temporalCouponCode ? 'temporalCouponCode' : 'default'

    setButtonConfig(buttonConfigs[configKey])
  }, [history, showDetails, productExchangeCoupon, setShowOrderNumber])

  if (showOrderNumber) {
    return <NumberOrder setShowOrderNumber={setShowOrderNumber} details={showDetails} />
  }

  return (
    <>
      <ButtonCloseMenu paramFn={goBack} />
      <div className="prize-detail">
        <div className="prize-item">
          <div className="prize-item-img">
            <img src={showDetails?.imageUrl} alt="Imagen del premio" />
          </div>

          <div className="prize-texts">
            <h2 className="prize-title">{showDetails?.title}</h2>

            <div className="prize-data space-y-1">
              <p className="prize-redeemed">
                {showDetails?.costInPoints > 0 ? 'Canjeado' : 'Ganado'} {formatDate(showDetails?.exchangeAt)}
              </p>

              <p className="prize-order">N°Orden {showDetails?.id}</p>

              {showDetails?.costInPoints > 0 && (
                <p className="prize-points">
                  {showDetails?.costInPoints} {POINTS_NAME}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="prize-info">
          <p className="prize-description">
            {
              showDetails.temporalCouponCode ? textServices.findByText('profile/prize/detail/descriptionCoupon', {
                es: 'Activa el cupón temporal para poder retirar tu premio cuando estés en el punto de retiro. Recuerda que solo tienes 7 días para retirar tu premio.',
                en: 'Activate the temporary coupon to be able to withdraw your prize when you are at the withdrawal point. Remember you only have 7 days to withdraw your prize.'
              })
                :
                textServices.findByText('profile/prize/detail/description', {
                  es: 'Si necesitas saber más detalles de tu envío ingresa al botón de abajo para conocer más. Recuerda que puedes cancelarlo únicamente antes de que se envíe al destino.',
                  en: 'If you need to know more details about your shipment, click the button below to know more. Remember you can cancel it only before it is sent to the destination.'
                })
            }
          </p>

          <div className="prize-btns">
            {buttonConfig.text !== 'VER COURRIER' && (
              <Button
                className={`prize-btn-courier ${buttonConfig.disabled ? 'opacity-20' : ''}`}
                onClick={buttonConfig.action}
                disabled={buttonConfig.disabled}
              >
                {buttonConfig.text}
              </Button>
            )}
          </div>
        </div>

        <div className="prize-stepper-container">
          <Steps trackingDetail={history?.trackingDetail} courier={history?.currier} />
          <Link to="/help"><p className="prize-help">Tengo un problema, necesito ayuda.</p></Link>
        </div>
      </div>
    </>
  )
}

export default Details
